// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"f2b8f7ec","290":"72c39581","356":"6557c7cb","930":"6770d9cf"}[chunkId] + ".chunk.js";
};